import { scrollToRegistration } from "@/config";

const RegisterButton = ({ testId, className = "" }) => (
    <button
        type="button"
        onClick={scrollToRegistration}
        data-testid={testId}
        className={`inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-neon/60 bg-neon/10 px-8 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-[#E2C6FF] shadow-[0_12px_45px_-12px_rgba(200,77,255,0.5)] transition-colors duration-300 hover:bg-neon/20 active:scale-[0.98] ${className}`}
    >
        Register for Webinar
    </button>
);

export default RegisterButton;
